export const useGetFAQs = async () => {
  try {
    const { data } = await useApiV3().get('/faqs');
    return data?.items || [];
  } catch (error) {
    console.log('Error: Failed retrieving FAQs', error);
    return [];
  }
}
